(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    
  const baseURL = "https://mjm.gemist.co";
  
  window.onload = function() {
    // Get the current URL of the parent page
    var url = window.location.href;
    
    // Get the query string from the URL
    var queryString = url.split('?')[1];
    
    // Create the iframe URL with the query string
    var iframeUrl = baseURL + "/designer/bands?" + queryString;
    
    // Set the iframe's source URL
    var iframe = document.getElementById("designer-iframe");
    iframe.src = iframeUrl;

    console.log("Starting designer setup");

    // wishlist plus
    // Executed after SWYM has loaded all necessary resources.
    function onSwymLoadCallback(swat) {
      // Please make all SWYM-related API calls inside this function.
      // You can use the swat argument within this scope.
      if (_swat) {
        console.log("Wishlist plus detected");
        // Define the list config
        let listConfig = {
          lname: "Designs", // unique list name.
        };
    
        listId = null;
    
        let onSuccess = function (newList) {
          // Executed when a new list is successfully created
          console.log("Wishlist setup OK");
          listId = newList.lid;
        };
    
        // Define error callback
        let onError = function (error) {
          // Error is an xhrObj
          console.log("Error while setting up wishlist", error);
        };
    
        _swat.createList(listConfig, onSuccess, onError);
      }
    }
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  };

  window.addEventListener(
    "message",
    function (event) {
      if (event.data) {
        try {
          const message = JSON.parse(event.data);
          console.log(message);
          
          switch (message.type) {
            case "buy":
              var id = message.product.Shopify.productVariant
                .split("/")
                .slice(-1)[0];
              var size = message.size;
  
              let product = {
                id: id,
                quantity: 1,
                properties: {
                  Size: size,
                },
              };
  
              const items = [product];
  
              if (message.diamond.variantId !== undefined) {
                let diamond = {
                  id: message.diamond.variantId.split("/").slice(-1)[0],
                  quantity: 1,
                };
                items.push(diamond);
              }
  
              cart = window.cart || 
                document.querySelector("cart-notification") ||
                document.querySelector("cart-drawer");
  
              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ items: items }),
              })
                .then((response) => {
                  if (cart && typeof cart.getCart === 'function') {
                    cart.getCart();
                  }
                  
                  var event = new Event('theme:product:added');
                  document.dispatchEvent(event);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
              break;
            case "favorite":
              var { id } = message.product;
  
              fetch(baseURL + "/api/products/" + id + "/shmetadata")
                .then((response) => response.json())
                .then((data) => {
                  var { productId, variantId, handle } = data;
  
                  // wishlist plus
                  if (_swat && listId) {
                    productId = String(productId.split("/").slice(-1)[0]);
                    variantId = String(variantId.split("/").slice(-1)[0]);
                    productUrl = "https://" + String(Shopify.shop) + "/products/" + handle;
                    
                    var product = {
                      epi: variantId, // Unique variant ID of the product
                      empi: productId, // Master Product Id of the product
                      du: productUrl, // Product URL
                    };

                    console.log("Product info to wishlist", product, listId);
                    
                    let onAddSuccess = function (addedListItem) {
                      // Success response is the added product.
                      console.log("Successfully added the Product to List");
                    };
                    
                    // Define error callback
                    let onError = function (error) {
                      // Error is an xhrObj
                      console.log(
                        "Error while adding the Product to the List",
                        error
                      );
                    };
  
                    _swat.addToList(listId, product, onAddSuccess, onError);
                  }
                  // other wishlist implementation
                  else {
                    // create element to save
                    var elementToSave = document.createElement("div");
                    elementToSave.dataset.id = productId.split("/").slice(-1)[0];
                    elementToSave.dataset.handle = handle;
  
                    // use the saveWishlist function that we made available from theme.js
                    // saveWishlist($(elementToSave));
                  }
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
  
              break;
            case "updateParams":
              // Get the parameter names from the message
              var paramNames = message.paramNames;
              var currentURL = new URL(window.location.href);
  
              // Loop through the parameter names
              paramNames.forEach(function (paramName) {
                // Retrieve the corresponding value from the message
                var paramValue = message[paramName];
  
                // Modify the query parameter of the parent URL with the value
                if (paramValue !== undefined) {
                  currentURL.searchParams.set(paramName, paramValue);
                }
              });
  
              // Replace the parent URL with the modified URL
              window.history.replaceState({}, "", currentURL.toString());
              break;
            case "download":
              const downloadHref = message.downloadHref;
              if (downloadHref) {
                window.open(downloadHref, "_blank");
              }
              break;
            case "copywindowlocation":
              // Get the current window location
              var windowLocation = window.location.href;
  
              // Use the Clipboard API to copy the window location to the clipboard
              navigator.clipboard
                .writeText(windowLocation)
                .then(function () {
                  console.log("Window location copied to clipboard successfully");
                })
                .catch(function (error) {
                  console.error(
                    "Failed to copy window location to clipboard:",
                    error
                  );
                });
              break;
            case "sendemail":
              let { emailContent, subject, recipient } = message;
              const currentPageLink = window.location.href;
              emailContent = emailContent.replace(
                "{{currentPageLink}}",
                currentPageLink
              );
  
              const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
                subject
              )}&body=${encodeURIComponent(emailContent)}`;
  
              if (mailtoLink) {
                window.open(mailtoLink, "_blank");
              }
              break;
            case "requestfullscreen":
              const designerIframe = document.querySelector("#designer-iframe");
              void designerIframe.requestFullscreen();
              break;
            default:
              break;
          }
        } catch (e) {}
      }
    },
    false
  );
  
  // This event takes care of setting the Designer's iframe's height using the already existing --header-height variable
  document.addEventListener("DOMContentLoaded", function () {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    console.log("isMobile", isMobile);
    
    const designerIFrameContainerElement = document.querySelector(
      ".designer-iframe-container"
    );

    const designerIFrameElement = document.querySelector("#designer-iframe");

    const resize_ob = new ResizeObserver(function(entries) {
      let rect = entries[0].contentRect;
  
      let height = rect.height;

      if (
        designerIFrameContainerElement !== null &&
        designerIFrameElement !== null &&
        height
        ) {
        const heigthValueString = isMobile
          ? `calc(100vh - ${height}px)`
          : `calc(100vh - ${height}px)`;

        console.log("Height value string", heightValueString);
      
        designerIFrameContainerElement.style.height = heigthValueString;
        designerIFrameElement.style.height = heigthValueString;
      }
    });
    resize_ob.observe(document.querySelector(".header-sections"));
  });

  } catch(e) { console.error(e); }
})();
})();
